export default class ModuleSixService {
  
  static getAliquot(taxation, taxationType){
    if(!taxation || taxationType == ""){
      return 0
    }
    
    /*OTHERS let sumOfOthers = 0
    if(this.moduleSix && this.moduleSix.others && this.moduleSix.others.length > 0){
      for (let i = 0; i < this.moduleSix.others.length; i++) {
        sumOfOthers += this.moduleSix.others[i].value
      }
    }*/

    if (taxationType.toUpperCase() == "SIMPLES NACIONAL"){
      //OTHERS return this.taxation.uniqueTaxation  + sumOfOthers
      return taxation.uniqueTaxation 
    }else{
      //OTHERS return this.taxation.pis + this.taxation.cofins + this.taxation.iss  + sumOfOthers;
      return taxation.pis + taxation.cofins + taxation.iss
    }
  }
  static getAdministrativeCosts(subTotalValue=0, administrativeCosts=0){
    return (subTotalValue * administrativeCosts) / 100
  }
  /**
   * @param {Number} amountOfModuleOne 
   * @param {Object} moduleTwo 
   */
  static getAmountOfModuleSix(budget, moduleSix, subTotalValue){

    let taxation = this.getTaxation(budget)
    let taxationType = this.getTaxationType(taxation)
    
    if(!taxation || taxationType == "")
      return 0

    let amount = 0
    let aliquot                         = this.getAliquot(taxation, taxationType)
    let administrativeCostsValue        = this.getAdministrativeCosts(subTotalValue, moduleSix.administrativeCosts)
    let basisOfCalculationForLucre      = this.getBasisOfCalculationForLucre(subTotalValue, administrativeCostsValue)
    let lucreValue                      = this.getLucre(moduleSix.lucre, basisOfCalculationForLucre)
    let basisOfCalculationForTaxation   = this.getBasisOfCalculationForTaxation(subTotalValue, administrativeCostsValue, lucreValue)
    
    if (taxationType.toUpperCase() == "SIMPLES NACIONAL"){
      //amount  = this.uniqueTaxationValue this.administrativeCostsValue + this.lucreValue + this.othersValue
      amount  = this.getUniqueTaxation(taxation, basisOfCalculationForTaxation)  +
                administrativeCostsValue  +
                lucreValue
    }else{
      //amount  = this.pisValue + this.cofinsValue + this.issValue this.administrativeCostsValue + this.lucreValue + this.othersValue
      amount  = this.getPis(taxation, basisOfCalculationForTaxation, aliquot) +
                this.getCofins(taxation, basisOfCalculationForTaxation, aliquot) + 
                this.getIss(taxation, basisOfCalculationForTaxation, aliquot) +
                administrativeCostsValue + 
                lucreValue
    }
    return amount
  }

  static getBasisOfCalculationForLucre (subTotalValue, administrativeCostsValue){
    return subTotalValue + administrativeCostsValue
  }
  static getBasisOfCalculationForTaxation(subTotalValue, administrativeCostsValue, lucreValue){
    return subTotalValue + administrativeCostsValue + lucreValue
  }
  static getCofins(taxation, basisOfCalculationForTaxation, aliquot){
    if(!taxation)
      return 0
    return (basisOfCalculationForTaxation / (100 - aliquot)) * taxation.cofins
  }
  static getIss(taxation, basisOfCalculationForTaxation, aliquot){
    if(!taxation)
      return 0
    return (basisOfCalculationForTaxation / (100 - aliquot)) * taxation.iss
  }
  static getLucre(lucre = 0, basisOfCalculationForLucre = 0){
    return (basisOfCalculationForLucre * lucre) / 100
  }
  
  static getOthers(others, aliquot, basisOfCalculationForTaxation){
    if(!others)
      return 0
    let sumOfOthers = 0
    for (let i = 0; i < others.length; i++)
      sumOfOthers += (basisOfCalculationForTaxation / (100 - aliquot)) * moduleSix.others[i].value
      
    return sumOfOthers
  }
  
  static getPis(taxation, basisOfCalculationForTaxation, aliquot){
    if(!taxation)
      return 0
    return (basisOfCalculationForTaxation / (100 - aliquot)) * taxation.pis
  }
  static getTaxation(budget){
    if(!budget || !budget.company || !budget.company.taxation)
      return 
    return budget.company.taxation
  }
  static getTaxationType(taxation){
    if(!taxation)
      return ""
    return taxation.taxationType
  }
  static getUniqueTaxation(taxation, basisOfCalculationForTaxation){
    if(!taxation)
      return 0
    return basisOfCalculationForTaxation * taxation.uniqueTaxation / 100
  }
} // class



// WEBPACK FOOTER //
// ./src/service/ModuleSixService.js